import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../actions/journeyBuilder';
import { togglePreview } from '../../../actions/journeyBuilder';

const TopbarBuilder = () => {
  const { autosavedAt } = useSelector(state => state);
  const { steps } = useSelector(state => state);
  const dispatch = useDispatch();

  const removeTempSteps = () => {
    steps.forEach((step, index) => {
      if (!step.stepId) {
        dispatch(
          actions.removeStep({
            index,
          }),
        );
      } else {
        dispatch(
          actions.updateStep({ index, step: { ...step, editing: false } }),
        );
      }
    });
  };

  return (
    <>
      <div className="JourneyBuilderTopbar-title">
        <h1>{t('journeys.builder.title')}</h1>
      </div>
      <div className="JourneyBuilderTopbar-actionButtons">
        {autosavedAt && (
          <div
            className="JourneyBuilderTopbar-autosaveTimestamp"
            data-testid="JourneyBuilderTopbar-autosaveTimestamp"
          >
            {t('journeys.builder.autosaved')} {autosavedAt}
          </div>
        )}
        <button
          type="button"
          children={t('journeys.builder.finish_editing')}
          className="JourneyBuilderTopbar-finishEditing"
          onClick={() => {
            removeTempSteps();
            dispatch(togglePreview());
          }}
        />
      </div>
    </>
  );
};

export default TopbarBuilder;
